import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TipoProcessamentoRecorrenciaEnum } from '../../../../../shared/enums/financas/tipo-processamento-recorrencia.enum';

@Component({
  selector: 'app-cr-confirm-acao-recorrente-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, FormsModule, MatRadioModule],
  templateUrl: './confirm-acao-recorrente-dialog.component.html',
  styleUrl: './confirm-acao-recorrente-dialog.component.css',
})
export class ConfirmAcaoRecorrenteDialogComponent implements OnInit {
  public title: string = '';
  public description: string = '';
  public buttonConfirm: string = 'Confirmar';
  public buttonClose: string = 'Cancelar';

  public tipoProcessamento: TipoProcessamentoRecorrenciaEnum = TipoProcessamentoRecorrenciaEnum.ApenasEsta;
  public TipoProcessamentoRecorrenciaEnum = TipoProcessamentoRecorrenciaEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmAcaoRecorrenteDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.title = this.data.title || 'Ação em Lançamento Recorrente';
      this.description =
        this.data.description || 'O que deseja fazer com as contas em aberto vinculadas à esta conta?';
      this.buttonConfirm = this.data.buttonConfirm || 'Confirmar';
      this.buttonClose = this.data.buttonClose || 'Cancelar';
    }
  }

  close(): void {
    this.dialogRef.close({ confirm: false });
  }

  confirm(): void {
    this.dialogRef.close({
      confirm: true,
      tipoProcessamento: this.tipoProcessamento,
    });
  }
}
